<template>
  <div class="form-group">
    <!-- <ckeditor
      id="ckeditor"
      :class="(data.customClass) ? data.customClass : ''"
      :editor="editor"
      v-model="inputValue"
      :config="editorConfig"
    ></ckeditor> -->
    <ckeditor v-model="inputValue" :config="editorConfig"></ckeditor>
  </div>
</template>
<script>
import { getToken } from "@/util/auth";
// ⚠️ NOTE: We don't use @ckeditor/ckeditor5-build-classic any more!
// Since we're building CKEditor from source, we use the source version of ClassicEditor.
// import ClassicEditor from "@ckeditor/ckeditor5-editor-classic/src/classiceditor";

import EssentialsPlugin from "@ckeditor/ckeditor5-essentials/src/essentials";
import BoldPlugin from "@ckeditor/ckeditor5-basic-styles/src/bold";
import ItalicPlugin from "@ckeditor/ckeditor5-basic-styles/src/italic";
import LinkPlugin from "@ckeditor/ckeditor5-link/src/link";
import ParagraphPlugin from "@ckeditor/ckeditor5-paragraph/src/paragraph";

//images plugins
import Image from "@ckeditor/ckeditor5-image/src/image";
import ImageToolbar from "@ckeditor/ckeditor5-image/src/imagetoolbar";
import ImageCaption from "@ckeditor/ckeditor5-image/src/imagecaption";
import ImageStyle from "@ckeditor/ckeditor5-image/src/imagestyle";
import ImageResize from "@ckeditor/ckeditor5-image/src/imageresize";

//image upload simpleUploadAdapter
import ImageUpload from "@ckeditor/ckeditor5-image/src/imageupload"; //shows the upload image icon
import SimpleUploadAdapter from "@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter";

export default {
  name: "CKeditor",
  props: {
    uniqueId: Number
  },

  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  data() {
    return {
      editorData: "",
      editorConfig: {
        // The configuration of the editor.
      }
      // editor: ClassicEditor
      // editorConfig: {
      //   // The configuration of the editor.
      //   placeholder: this.placeholder ? this.placeholder : "",
      //   plugins: [
      //     EssentialsPlugin,
      //     BoldPlugin,
      //     ItalicPlugin,
      //     LinkPlugin,
      //     ParagraphPlugin,
      //     Image, ImageToolbar, ImageCaption, ImageStyle, ImageResize,
      //     ImageUpload,
      //     SimpleUploadAdapter
      //   ],
      //   toolbar: {
      //     items: ["bold", "italic", "link", "undo", "redo", "imageUpload"]
      //   },
      //   image: {
      //       // You need to configure the image toolbar, too, so it uses the new style buttons.
      //       toolbar: [ 'imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:full', 'imageStyle:alignRight' ],

      //       styles: [
      //           // This option is equal to a situation where no style is applied.
      //           'full',

      //           // This represents an image aligned to the left.
      //           'alignLeft',

      //           // This represents an image aligned to the right.
      //           'alignRight'
      //       ]
      //   },
      //   simpleUpload: {
      //       // The URL that the images are uploaded to.
      //       uploadUrl: 'http://localhost:8000/api/upload/images',

      //       // Headers sent along with the XMLHttpRequest to the upload server.
      //       headers: {
      //         Authorization: 'Bearer '+getToken()
      //       }
      //   }
      // }
    };
  },
  methods: {}
};
</script>
<style>
</style>
